import { createFileRoute } from '@tanstack/react-router';
import { AdminPlansPage } from '../../features/billing';

export const Route = createFileRoute('/admin/plans/')({ component: AdminPlansPage });
